import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { AppSettings } from 'src/app/app-settings';
import { QrCodeComponent } from 'src/app/components/bloques/qr-code/qr-code.component';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { ApiBusinessService } from 'src/app/services/api-business.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BondsServices } from 'src/app/services/bonds.service';
import { BusinessService } from 'src/app/services/business.service';
import { EventosService } from 'src/app/services/eventos.service';
import { PanelAdminService } from 'src/app/services/panel-admin.service';
import { PlacesService } from 'src/app/services/places.service';
import { CreateBondComponent } from '../create-bond/create-bond.component';
import { SelectEventBondComponent } from '../select-event-bond/select-event-bond.component';

@Component({
  selector: 'app-events-panel',
  templateUrl: './events-panel.component.html',
  styleUrls: ['./events-panel.component.scss']
})
export class EventsPanelComponent implements OnInit {

  business: any;
  place!: any;
  placesEnabled: any[] = [];
  placeSelected: any = null;
  eventos: any[] = [];
  profile!: any;
  searchText!: string;
  now: Date = new Date();
  @Input() idVenue!: any;
  @Input() draft!: any;

  // Filters
  activeFilters: boolean = false;
  openDatePicker: boolean = false;
  datesRange: any = null;
  stringDate: string = null;
  statusFilter: string = null;
  statusOptions = [
    { id: 'available', name: 'Disponible' },
    { id: 'disabled', name: 'Desactivado' },
    { id: 'finished', name: 'Terminado' },
  ];
  // Estado
  loadingStateChange: { [key: number]: boolean } = {};
  displayedColumns: string[] = ['actions', 'titulo', 'qr', 'location', 'fecha', 'vendidas', 'precio', 'status'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();

  @ViewChild(MatSort) sort: MatSort = new MatSort;
  sorted: any = { sortedBy: 'start_date', sort: 'desc' };

  page = 1;

  urlImages: string = AppSettings.MEDIA_URI + '/events_images/';
  @Output() changeTag: EventEmitter<any> = new EventEmitter<any>();
  loaded: boolean = false;
  loadingPage: boolean = true;
  allowCreate!: any;

  finishScroll: boolean = false;
  @ViewChild('containerScroll', { static: false }) containerScroll: ElementRef;
  private searchTerms = new Subject<string>();
  private eventsRequest?: Subscription;
  private loadGeneration = 0;

  constructor(private panelService: PanelAdminService, private businessService: BusinessService,
    private dialog: MatDialog, private router: Router, private auth: AuthenticationService,
    private bondService: BondsServices, private apiBusiness: ApiBusinessService,
    private placeService: PlacesService, private eventosService: EventosService) { }

  ngOnInit(): void {
    this.profile = this.auth.getProfile();
    this.now.setHours(0);
    this.now.setMinutes(0);
    let rolesProfile = this.auth.getProfile()?.roles.map((role: any) => role.name);
    this.allowCreate = rolesProfile?.find((element) => (element == 'admin' || element == 'superadmin' || element == 'ACCESS_CLOUD' || element == 'ACCOUNT_OWNER' || element == 'ACCESS_EXTERN_EVENTS' || element == 'ACCESS_ADMIN' || element == 'ACCESS_MANAGER' || element == 'CREATE_EVENTS'));

    // Restaurar filtros guardados (al volver desde el detalle de un evento)
    const stored = this.eventosService.getEventsPanelFilters();
    if (stored) {
      this.searchText = stored.searchText ?? null;
      // placeSelected se restaura después de cargar los espacios
    }
  }

  ngAfterViewInit() {
    this.displayedColumns = !this.draft ?
      ['actions', 'titulo', 'qr','location', 'fecha', 'vendidas', 'precio', 'status'] :
      ['actions', 'titulo', 'qr','location', 'fecha', 'precio', 'status'];

    let dataLoaded = false;

    this.apiBusiness.changed.subscribe({
      next: (value) => {
        this.business = JSON.parse(localStorage.getItem('business') || '{}');
        if (value && this.business?.id) {
          dataLoaded = true;
          this.loadPlaces();
          // updateEvents se llama dentro de loadPlaces
        }
      }
    })

    this.searchTerms.pipe(
      debounceTime(500),
      distinctUntilChanged(),
    ).subscribe(items => {
      this.searchText = items;
      this.eventosService.setEventsPanelFilters(this.searchText, this.placeSelected);
      this.updateEvents();
    });

    // Cargar datos iniciales si business ya está en localStorage y no se cargó via changed observable
    setTimeout(() => {
      if (!dataLoaded) {
        this.business = JSON.parse(localStorage.getItem('business') || '{}');
        if (this.business?.id) {
          this.loadPlaces();
          // updateEvents se llama dentro de loadPlaces
        }
      }
    }, 500);
  }

  getData() {
    const generation = this.loadGeneration;
    let places = [];
    if (this.placeSelected) {
      places = [this.placeSelected];
    }
    if (this.idVenue) {
      places = [this.idVenue];
    }
    const fromDate = this.datesRange?.min || null;
    const toDate = this.datesRange?.max || this.datesRange?.min || null;
    // El filtro "Desactivado" (status=disabled) busca publish=false + draft=false, pero
    // el back hace mutuamente excluyentes draft y publish: mandar draft=false impone
    // publish=true y la consulta se queda sin resultados posibles. Como el propio status
    // ya fija los dos flags, en ese caso no se manda draft (null = no viaja en la URL).
    const draftParam = !this.draft && this.statusFilter === 'disabled' ? null : this.draft;
    this.eventsRequest = this.businessService.getEventsCompanyFilter(this.business?.id, this.page, this.searchText, this.sorted, places, draftParam, false, toDate, true, null, fromDate, this.statusFilter || null).subscribe({
      next: (res) => {
        if (generation !== this.loadGeneration) return;
        this.eventos = this.eventos.concat(res.data.data);
        if (res.data.data.length <= 0 || res.data.data.length < 15) {
          this.finishScroll = true;
        }
        this.dataSource = new MatTableDataSource(this.eventos);
        this.dataSource.sort = this.sort;

        this.loaded = true;
        this.loadingPage = false;
      }
    })
  }

  updateEvents() {
    this.eventsRequest?.unsubscribe();
    this.loadGeneration++;
    this.page = 1;
    this.loadingPage = true;
    this.finishScroll = false;
    this.eventos = [];
    this.getData();
  }

  loadPlaces() {
    if (!this.business?.id) return;
    this.placeService.getListFilterPlaces(this.business.id, 1, null, null, true).subscribe({
      next: (res) => {
        const allPlaces = Array.isArray(res) ? res : res?.data?.data || res?.data || [];
        this.placesEnabled = this.placeService.filterManagedPlaces(allPlaces, this.business?.id);
        // Restaurar placeSelected aquí para que mat-select encuentre las opciones ya cargadas
        const stored = this.eventosService.getEventsPanelFilters();
        if (stored?.placeSelected) {
          this.placeSelected = stored.placeSelected;
        }
        // Lanzar la carga de eventos aquí para garantizar que placeSelected está listo
        this.updateEvents();
      }
    });
  }

  changePlaceFilter() {
    this.eventosService.setEventsPanelFilters(this.searchText, this.placeSelected);
    this.updateEvents();
  }

  toggleFilters() {
    this.activeFilters = !this.activeFilters;
    this.openDatePicker = false;
  }

  selectDates(event: any) {
    this.datesRange = event;
    this.openDatePicker = false;
    if (event?.min) {
      const minDisplay = this.formatDateDisplay(event.min);
      const maxDisplay = event.max && event.max !== event.min ? this.formatDateDisplay(event.max) : null;
      this.stringDate = maxDisplay ? `${minDisplay} - ${maxDisplay}` : minDisplay;
    } else {
      this.stringDate = null;
    }
    this.updateEvents();
  }

  // Convierte 'YYYY-MM-DD' → 'DD/MM/YYYY' para mostrar en el input
  private formatDateDisplay(yyyymmdd: string): string {
    if (!yyyymmdd) return '';
    const [year, month, day] = yyyymmdd.split('-');
    return `${day}/${month}/${year}`;
  }

  clearFilters() {
    this.searchText = null;
    this.placeSelected = null;
    this.datesRange = null;
    this.stringDate = null;
    this.statusFilter = null;
    this.activeFilters = false;
    this.eventosService.clearEventsPanelFilters();
    this.updateEvents();
  }

  searchEvents(event) {
    this.searchTerms.next(event);
  }

  openEvent(event: any) {
    const url = this.draft ? 'events/draft' : 'events';
    if (this.idVenue) {
      const urlFront = window.location.origin + '/panel-control/' + url + '/detail/info-event/' + event.id + '?venue=' + this.idVenue;
      window.open(urlFront, '_blank');
    } else {
      this.router.navigate(['/panel-control/' + url + '/detail/info-event', event.id]);
    }
  }

  getStatus(event: any) {
    if (event.draft) {
      return { color: '#7A7A7A', status: 'Borrador' };
    }
    // Verificar estados de negocio primero (solo si son explícitamente TRUE)
    if (event.cancelled === true) {
      return { color: '#C41E3A', status: 'Cancelado' };
    }
    if (event.sold_out === true) {
      return { color: '#FFA500', status: 'Aforo Completo' };
    }
    if (event.active_sales === false) {
      return { color: '#2196F3', status: 'Ventas Detenidas' };
    }
    if (event.active === false) {
      return { color: '#7A7A7A', status: 'Desactivado' };
    }
    // Verificar si el evento ha terminado
    if (event.end_date && new Date(event.end_date) < this.now) {
      return { color: '#B75470', status: 'Terminado' };
    }
    if (!event.publish) {
      return { color: '#7A7A7A', status: 'Desactivado' };
    }
    // Evento activo: ha comenzado pero no ha terminado
    if (new Date(event.start_date) <= this.now) {
      return { color: '#21CB7C', status: 'Activo' };
    }
    // Evento disponible: aún no ha comenzado
    return { color: '#21CB7C', status: 'Disponible' };
  }

  openCreateEvent() {
    this.router.navigate(['/panel-control/events/new-event/info-event']);
  }

  // Sort
  sortData(sort: Sort) {
    if (this.eventos.length > 1) {
      const isAsc = (sort.direction === 'asc') ? 'asc' : 'desc';
      if (sort.direction) {
        this.sorted = { sortedBy: sort.active, sort: isAsc };
      } else {
        this.sorted = null;
      }
      this.updateEvents();
    }
  }

  openCreateBond(object?: any, back?: boolean) {
    let bondRes = object;
    const dialogRef = this.dialog.open(CreateBondComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      disableClose: true,
      width: '750px',
      data: {
        idCompany: this.business.id,
        object: object
      }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res?.bond) {
        if (!bondRes) {
          bondRes = { id: null, name: '', type: '', cuantity: 0, events: [] }
        }
        bondRes.name = res.bond.name;
        bondRes.type = res.bond.type;
        bondRes.cuantity = res.bond.cuantity;
        res.bond.events = bondRes?.events;
        this.openSelectEvents(res.bond);
      }
    });
  }

  openSelectEvents(object: any, bond?: any) {
    const dialogRef = this.dialog.open(SelectEventBondComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      width: '750px',
      disableClose: true,
      data: {
        idCompany: this.business.id,
        object: bond
      }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res.back) {
        this.openCreateBond(object, true);
      }
      if (res.events) {
        this.sendCreateBond(object, res.events);
      }
    });
  }

  sendCreateBond(object: any, events: any) {
    const pass_items = events.map((e: any) => ({ event_id: e.id || e, session_ids: [] }));
    let payload = {
      name: object.name,
      rule_type: 'pass',
      discount_mode: object.type,
      discount_value: object.cuantity,
      pass_items,
      start_date: object.start_date,
      end_date: object.end_date,
      apply_scope: 'company',
      active: true
    };
    this.bondService.createBond(payload).subscribe({
      next: (res) => {
        this.openInfoCard('Abono creado correctamente.');
      },
      error: (err) => {
        this.openInfoCard('¡Vaya! Ha ocurrido un error al crear el abono, vuelve a intentarlo más tarde.');
      }
    });
  }

  openInfoCard(msg: string, disabledClose: boolean = false) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: ['info-dialog'],
      disableClose: disabledClose,
      data: {
        text: msg
      }
    });
  }

  //Pagination
  @HostListener('window:scroll', ['$event'])
  @HostListener('scroll', ['$event'])
  public isScrolledInfinityView(event) {
    if (!this.loadingPage) {
      if (!this.finishScroll) {
        const element = this.containerScroll.nativeElement.getBoundingClientRect();
        let bottomShown = element.bottom <= window.innerHeight;
        if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
          bottomShown = true;
        }
        if (bottomShown && !this.finishScroll) {
          this.page++;
          this.loadingPage = true;
          setTimeout(() => {
            this.getData();
          }, 200);
        }
        // }
      } else {
        this.finishScroll = true;
      }
    }
  }

  // Open QR modal (generated on frontend)
  dowloadQR(event: any) {
    this.dialog.open(QrCodeComponent, {
      panelClass: 'info-dialog',
      data: {
        localizador: this.buildEventPublicUrl(event),
        qrTitle: 'Enlace evento'
      }
    });
  }

  private buildEventPublicUrl(event: any): string {
    let titleUrl = (event?.title || '')
      .replace(/[^\w\s]/g, '-')
      .replace(/\s+/g, '-')
      .replace(/-{2,}/g, '-')
      .replace(/-{3,}/g, '-');
    if (titleUrl?.charAt(titleUrl.length - 1) === '-') {
      titleUrl = titleUrl.slice(0, -1);
    }
    let url = `${AppSettings.FRONT}`;
    url += `/event/${event?.id}-${titleUrl?.toLowerCase()}`;
    return url;
  }

  // ========== MÉTODOS PARA CAMBIAR ESTADO DEL EVENTO DESDE PANEL ==========

  changeEventStateFromPanel(event: any, newState: string) {
    if (this.loadingStateChange[event.id]) return;
    
    this.loadingStateChange[event.id] = true;
    this.eventosService.changeEventState(event.id, newState).subscribe({
      next: (data) => {
        // Actualizar las propiedades del evento según la respuesta
        if (data && data.data) {
          Object.assign(event, data.data);
          // Actualizar el dataSource para reflejar los cambios
          this.dataSource.data = [...this.dataSource.data];
        }
        this.loadingStateChange[event.id] = false;
        this.openInfoCard('El estado del evento se ha actualizado correctamente.');
      },
      error: (err) => {
        this.loadingStateChange[event.id] = false;
        this.openInfoCard('Error al cambiar el estado del evento. Por favor, intenta de nuevo.');
        console.error('Error changing event state:', err);
      }
    });
  }

  // Métodos específicos para cada estado
  onPanelStopSales(event: any) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: true,
        text: '¿Deseas detener las ventas de este evento?',
        warning: true,
        btnCancel: true,
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.changeEventStateFromPanel(event, 'stop_sales');
      }
    });
  }

  onPanelCancel(event: any) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: true,
        text: '¿Deseas cancelar este evento?',
        warning: true,
        btnCancel: true,
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.changeEventStateFromPanel(event, 'cancelled');
      }
    });
  }

  onPanelSoldOut(event: any) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: true,
        text: '¿Deseas marcar este evento como aforo completo?',
        warning: true,
        btnCancel: true,
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.changeEventStateFromPanel(event, 'sold_out');
      }
    });
  }

  onPanelDeactivate(event: any) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: true,
        text: '¿Deseas desactivar este evento?',
        warning: true,
        btnCancel: true,
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.changeEventStateFromPanel(event, 'deactivate');
      }
    });
  }

  onPanelRestore(event: any) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: true,
        text: '¿Deseas restaurar este evento a su estado normal?',
        warning: false,
        btnCancel: true,
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.changeEventStateFromPanel(event, 'normal');
      }
    });
  }
}
